import { PropsWithChildren, useRef } from "react"
import { Button, CommandButton, CustomPrintHover, Modal } from "components/actions"
import ReactToPrint from "react-to-print"
import { useToggle } from "utils"

export function PrintTransaction(params: PropsWithChildren<{
  loading?: boolean,
  withImagePrint?: boolean,
  setWithImagePrint?: (value: boolean) => void
  setWithValue?: (value: boolean) => void
}>): JSX.Element {
  const { isActive, toggle } = useToggle(false)

  return (
    <>

      {params.withImagePrint || params.setWithValue ? (
        <CustomPrintHover
          // onClick={(withImage) => {
          //   params.setWithImagePrint?.(withImage)
          //   toggle()
          // }}
          onPrint={(mode) => {
            if (mode === "WITH_VALUE") {
              params.setWithValue?.(true)
              toggle()
            }

            if (mode === "WITHOUT_PICTURE") {
              params.setWithImagePrint?.(false)
              params.setWithValue?.(false)
              toggle()
            }

            if (mode === "WITH_PICTURE") {
              params.setWithImagePrint?.(true)
              params.setWithValue?.(false)
              toggle()
            }
          }}
        />

      ) : (
        <CommandButton
          actiontype="print"
          loading={params.loading ? "true" : undefined}
          onClick={toggle}
        />
      )}

      {isActive && (
        <PrintTransactionModal toggle={toggle}>
          {params.children}
        </PrintTransactionModal>
      )}
    </>
  )
}

export function PrintTransactionModal(params: PropsWithChildren<PrintModalTransactionType>) {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <Modal isOpen title="Print Preview" closeModal={params?.toggle}>
      <Modal.Body>
        <section ref={ref}>{params?.children}</section>
      </Modal.Body>

      <Modal.Footer>
        <section className="flex justify-end">
          <Button color="error" onClick={params?.toggle}>
            CANCEL
          </Button>

          <ReactToPrint
            content={() => ref.current}
            trigger={() => (
              <Button
                color="primary"
                loading={params?.isLoading ? "true" : undefined}
              >
                PRINT
              </Button>
            )}
          />

          {params?.isLandscape && (
            <style>
              {`
                @media print {
                  @page {
                    size: landscape;
                  }
                }
              `}
            </style>
          )}
        </section>
      </Modal.Footer>
    </Modal>
  )
}

type PrintModalTransactionType = {
  isLoading?: boolean
  isLandscape?: boolean
  toggle: () => void
}